<template>
  <div class="auth">
    <loading v-if="loading" />
    <div class="page-content">
      <div class="container-fluid mar-top-100 mar-bot-100">
        <div class="row">
          <div class="col-md-6 col-md-offset-3">
            <div class="text-center">
              <div class="logo">
                <serenity-logo-svg />
              </div>
              <div class="tab-theme">
                <div class="tab-content">
                  <main-form-auth
                    @authByEmail="authByEmail"
                    :loading="loaders.auth"
                    @handleInput="handleInput"
                    :emailRemember="settings.emailRemember"
                    :email="auth.email"
                    @remember="remember"
                    v-if="routeName === 'auth'"
                  />
                  <main-form-reset
                    @handleInput="handleInput"
                    :loading="loaders.auth"
                    :email="auth.email"
                    @resetPassword="resetUserPassword"
                    v-if="routeName === 'reset'"
                  />
                  <main-form-restore
                    @handleInput="handleInput"
                    :loading="loaders.auth"
                    v-if="routeName === 'restore'"
                  />
                  <main-form-complete
                    @handleInput="handleInput"
                    :loading="loaders.auth"
                    v-if="routeName === 'auth_complete'"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import MainFormAuth from "@/components/Auth/MainFormAuth.vue";
import MainFormReset from "@/components/Auth/MainFormReset.vue";
import MainFormRestore from "@/components/Auth/MainFormRestore.vue";
import MainFormComplete from "@/components/Auth/MainFormComplete.vue";
export default {
  components: {
    MainFormAuth,
    MainFormReset,
    MainFormRestore,
    MainFormComplete
  },
  computed: {
    ...mapState("app", ["loading", "loaders", "auth"]),
    ...mapState("user", ["settings"]),
    routeName() {
      return this.$route.name;
    }
  },
  methods: {
    ...mapActions("app", ["setAuthData", "setLoading"]),
    ...mapActions("user", [
      "authByEmail",
      "resetUserPassword",
      "addUserSettings"
    ]),
    handleInput({ target }) {
      const { name, value } = target;
      this.setAuthData({ name, value });
      if (name === "email" && this.settings.emailRemember) {
        this.remember({ target });
      }
    },
    remember({ target }) {
      this.addUserSettings({
        emailRemember: target.checked,
        email: this.auth.email
      });
    }
  },
  mounted() {
    if (this.settings.emailRemember) {
      this.setAuthData({ name: "email", value: this.settings.email });
    }
  },
  watch: {
    settings: {
      deep: true,
      handler() {
        if (this.settings.emailRemember) {
          this.setAuthData({ name: "email", value: this.settings.email });
        }
      }
    }
  }
};
</script>
